export const COOKIE_POLICY = 'viewed_cookie_policy';
export const COOKIE_POLICY_NEC = 'cookielawinfo-checkbox-necessary';
export const COOKIE_POLICY_UNNEC = 'cookielawinfo-checkbox-non-necessary';
